//FIQ-1228: The tag column is hardcoded throughout codebase so excluded from the assetsFields array
export const assetFields = [
    {
        field: "quantity",
        description: "The count of the number of assets",
        importance: 1.5,
        align: "right",
        format: (v) => {
            const result = !v ? 1 : +v
            if (Number.isNaN(result)) return 1
            return result
        },
    },
    // {
    //     field: "rowFilter",
    //     label: "Row Filter",
    //     description: "Whether the row should be imported, leave blank for no filter",
    //     importance: 0.1,
    //     allowAdditional: true,
    //     noSummary: true,
    //     allowFixedValue: false,
    // },

    {
        field: "unitOfMeasurement",
        label: "UOM",
        description: "The unit of measurement for the quantity",
        importance: 1.55,
    },
    {
        label: "Asset Type",
        field: "assetType",
        description: "The asset type derived from manufacturer and model",
        notInAssetImport: true,
        noSummary: true,
        hiddenByRollout: true,
    },
    {
        label: "Manufacturer Makes",
        field: "manufacturerMakes",
        description: "The equipment normally made by the manufacturer",
        notInAssetImport: true,
        noSummary: true,
    },
    {
        label: "AI Suggested Asset Type",
        legacyLabel: "Computed Type",
        field: "aiType",
        description: "The AI derived type of the asset",
        notInAssetImport: true,
    },

    {
        label: "AI Suggested Parent",
        legacyLabel: "Computed Parent",
        field: "aiParent",
        description: "The AI Parent of the asset type",
        notInAssetImport: true,
    },
    {
        label: "Reviewed Type",
        field: "reviewedTypeName",
        description: "The reviewed type of the asset",
        notInAssetImport: true,
        requiresRollout: true,
    },
    {
        label: "Reviewed Parent",
        field: "reviewedParent",
        description: "The reviewed Parent of the asset type",
        notInAssetImport: true,
        requiresRollout: true,
        format: (v) => v || "N/A",
    },
    {
        field: "assetCriticality",
        description: "How important the asset is to the operation of the building or its safety.",
    },
    {
        field: "category",
        description: "The category into which the asset falls.",
        importance: 3,
    },
    {
        field: "description",
        description: "A description of the asset",
    },
    {
        field: "type",
        label: "Imported Asset Type",
        legacyLabel: "Imported Type",
        notInAssetImport: true,
    },
    {
        field: "facility",
        description: "The facility or building in which the asset exists.",
        importance: 2,
    },
    {
        field: "floor",
        description:
            "The floor of the facility in which the asset resides.  This may also be things like 'Site' meaning the area outside of the core building.",
        importance: 2,
    },
    {
        field: "space",
        description: "The space or room in which the asset is to be found.",
        importance: 2,
    },
    {
        field: "code",
        description: "A third party code for the asset, such as an NRM code or a Uniclass code.",
        importance: 3,
    },
    {
        field: "system",
        description: "The system to which the asset belongs.",
        importance: 3,
    },
    {
        field: "manufacturer",
        description: "The company that manufactured the asset.",
    },
    {
        field: "model",
        description: "The model identifier of the asset.",
    },
    {
        field: "condition",
        description: "The current condition of the asset.",
    },
    {
        field: "serialNumber",
        description: "The serial number of the asset.",
    },
    {
        field: "energyEfficiency",
        description: "The energy efficiency rating of the asset.",
    },
    {
        field: "carbon",
        description: "The carbon rating of the asset.",
    },
    {
        field: "annualServiceDate",
        description: "The date on which the asset is due for an annual service.",
    },
    {
        field: "warrantyExpiry",
        description: "The date on which the warrant for the asset expires.",
    },
    {
        field: "sfg20Code",
        label: "SFG20 (Imported) Code",
        description: "The SFG20 schedule code(s) an asset is maintained under",
    },
    {
        field: "mappedSchedules",
        label: "SFG20 (Mapped) Code",
        description: "The SFG20 schedule code(s) currently mapped to this asset",
        notInAssetImport: true,
    },
    {
        field: "installationDate",
        description: "The date on which the asset was installed",
    },
    {
        field: "expectedLifespan",
        description: "The expected service life / replacement cycle length for an asset",
    },
]

export const importerAssetFields = [
    {
        field: "tag",
        label: "Asset Tag",
        description: "The asset tag is the unique id you have for an asset.",
        importance: 1,
        unique: true,
        required: true,
    },
    {
        field: "type",
        label: "Asset Type",
        description: "The asset type is the type of the asset that should be mapped against an SFG20 code.",
        importance: 1,
        required: true,
        multiple: true,
    },
    ...assetFields,
]
